import React, { Component } from "react";
import "./personalloanhome.css";
import { t } from "i18next";
import * as Bl from "../../../businesslogic";
import personalLoan from "../../../assets/svgs/personal_loan.svg";
import {
  BreadCrumb,
  Button,
  TitleView,
  SideModel,
} from "../../components";
import { getLiabilityPathName, getUserId } from "../../common";
import { LIABILITIES_CATEGORY } from "../../constants";

const newLiability = {
  userid: "",
  liabilitiescategory: LIABILITIES_CATEGORY.PERSONAL_LOAN,
  description: "",
  loanissuedby: "",
  maturityyear: 0,
  currentvalue: 0,
  maturityage: 0,
  isincludefinancialplan: false
};

class PersonalLoanHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDrawer: false,
      liabilityData: [],
      newLiabilityData: new Bl.Liability({...newLiability, userid: getUserId()}),
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }
  
  onPressAddPersonalLoan() {
    this.props.navigate("/personalloandetail", {
      state: { liabilityData: this.state.newLiabilityData, isEditView: false },
    });
  }



  renderNavView() {
    const items = getLiabilityPathName("PersonalLoan");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("plTitle");
    return <TitleView title={title} />;
  }

  renderProfileView() {
    return (
      <div className="phome_profile_view">
        <img src={personalLoan} alt={t("plTitle")} className="phome_icon" />
        <div className="phome_info_view">{t("plInfo")}</div>
        <div className="phome_add_property">
          <Button
            buttonName={t("plButton")}
            onPressButton={this.onPressAddPersonalLoan.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  renderContentView() {
    return (
      <div className="phome_content_view">
        {this.renderTitleView()}
        {this.renderProfileView()}
      </div>
    );
  }

  render() {
    return (
      <div className="phome_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {/* {this.renderDrawerContent()} */}
      </div>
    );
  }
}

export default PersonalLoanHome;
